require('./helpers/bundle-manifest').register(JSON.parse("{\"EVgbq\":\"index.7d0170e3.js\",\"iVEgw\":\"background.9da02ee5.png\"}"));